import { env } from './env';

/**
 * Runtime configuration that can be injected without rebuild
 */
export function getRuntimeConfig() {
  // Try to get config from window (injected at runtime)
  if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__;
  }

  // Fallback to environment variables
  return {
    apiUrl: env.API_URL,
    features: {
      analytics: env.ENABLE_ANALYTICS,
      errorReporting: env.ENABLE_ERROR_REPORTING,
      featureX: env.ENABLE_FEATURE_X,
    },
    environment: env.APP_ENV,
  };
}

export const config = getRuntimeConfig();